<template>
  <!-- 党的思想 -->
  <div :key="domKey">
    <div style="position:relative">
      <TopButtom v-bind:buttonlist="buttonlist"></TopButtom>
    </div>
    <div class="tabcpage" v-show="ifShowList">
      <div class="rowA">
        <div class="english">
          THE RULE OF LAW AND THE BRIGADE WALK TOGETHER
        </div>
        <div class="chinese">法治与“旅”同行</div>
      </div>
      <div class="rowB">
        <div class="body">
          <div class="line"></div>
          <div v-for="item in datalist" :key="item.key">
            <div style="display:flex;flex-direction:row" @click="seeInfo(item)">
              <div class="middleDiv">
                <img :src="item.icon" class="middleImg" v-if="item.icon != null" />
                <img src="@/assets/image/party2.png" class="middleImg" v-else />
              </div>
              <div style="display:flex;flex-direction:column">
                <div class="topTitle">{{ item.title }}</div>
                <div class="desc" style="margin-top:1.57vh">{{ item.time }}</div>
                <div class="desc">{{ item.introduce }}</div>
              </div>
            </div>
            <div class="line" style="margin-top:1.389vh"></div>
          </div>
          <div class="footer">
            <NewPagunation :nowCurrent="current" :total="total" :pageSize="pageSize" @getPage="getPage"></NewPagunation>
          </div>
        </div>
      </div>
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:11px;">武夷山景区</div>
            <div style="margin-top:11px">天下难寻</div>
            <div style="margin-top:11px">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
    <DetailsInfo :info="info" @closed="closed" v-show="!ifShowList"></DetailsInfo>
  </div>
</template>

<script>
  import DetailsInfo from "./detailsInfo";
  import "@/css/listVertical.css";
  import { getMenuOpenList } from "@/api/publicApi";// 0,'about_info',1,1
  import { addHits } from "@/util/publicHits";
  import NewPagunation from "@/components/common/NewPagunation.vue";
  import TopButtom from "@/components/common/TopButtom.vue";
  export default {
    name: "TabApage",
    components: { TopButtom, NewPagunation, DetailsInfo },
    inject: ["reload"],
    data() {
      return {
        ifShowList: true,//是否显示列表
        info: {},
        domKey: '',
        current: 1,
        pageSize: 3,
        total: 0,
        datalist: [],
        buttonlist: [
          {
            id: 1,
            leftS: "left:1.5625vw",
            leftX: "left:1.458vw",
            title: "法治与“旅”同行",
            noCheckX: false
          }
        ]
      };
    },
    mounted() {
      this.getPartyRuleLawFunction()
    },
    methods: {
      async del() {
        this.reload();
      },
      //分页
      getPage(current) {
        this.current = current;
        this.getPartyRuleLawFunction()
      },
      //返回
      closed() {
        this.getPartyRuleLawFunction()
        this.ifShowList = true;
      },
      //详情
      seeInfo(info) {
        if (info.status) {
          if (info.status === 1) {
            //增加点击量
            addHits(info.id);
            this.info = info;
            this.ifShowList = false;
          } else {
            window.open(info.brief)
          }
        } else {
          //增加点击量
          addHits(info.id);
          this.info = info;
          this.ifShowList = false;
        }
      },
      //法治
      async getPartyRuleLawFunction() {
        const { code, data } = await getMenuOpenList(0, 'partyMenu3', this.current, this.pageSize);
        if (code == 200) {
          this.datalist = data.records;
          let BASE_URL = this.Global;
          this.datalist.forEach(element => {
            element.introduce != null
              ? (element.introduce = element.introduce.slice(0, 176) + ".....")
              : "";
            element.icon != null
              ? (element.icon = `${BASE_URL}${element.icon}`)
              : "";
          });
          this.total = data.total;
        }
      },
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/party/tabFaZhi.vue